import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import LoggerFactory from 'live/services/logger'
import serviceLocator from 'live/services/service-locator'

import { IUpdateModeFrontPresenter, UpdateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'
import { IBarrier } from 'plugin-codaf-risk-ext-bowtie/types'

import { enUS, ptBR } from './i18n'
import { QuantitativeLopaScaling } from './updateMode/QuantitativeLopaScaling'

export const logger = LoggerFactory('plugin-quantitative-live-event')

const locales = { pt_br: ptBR, en_us: enUS }
i18n.add(locales[locale ?? 'en_us'])

function requestValidationArray(barrier: IBarrier): string[] {
  const errorsArray: string[] = []

  return errorsArray
}


const quantitativeLopaScalingPresenter: IUpdateModeFrontPresenter = {
  label: 'Quantitative Lopa Scaling',
  method: 'QUANTITATIVE',
  component: QuantitativeLopaScaling,
  updateModeCode: 'quantitative_lopa_scaling',
  validationFunction: requestValidationArray
}

serviceLocator.getService('dra:updatemodefrontservice').then((updateModeFrontAPI: unknown) => {
  try {
      (updateModeFrontAPI as UpdateModeFrontAPI).addUpdateModeFrontPresenter(quantitativeLopaScalingPresenter)
      logger.info('front sucesseful registered to DRA engines')
  } catch (e) {
      logger.error(e)
  }
})